<script>
import Service from '../../../services/fiscal-notification';
import CommonConstants from '../../../common/Constants';
import config from '../../../common/genericPanelConf';
import Utils from '../../../common/Utils';
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

import GenericCustomMasterDataAutocompleteV2 from '../../../components/generic/GenericCustomMasterDataAutocompleteV2.vue';
import ResponsiveButton from '../../../components/generic/ResponsiveButton.vue'
import GenericDataTable from '../../../components/generic/GenericDataTable.vue'

export default{
    setup: () => ({ v$: useVuelidate() }),
  components: {
        GenericCustomMasterDataAutocompleteV2,
        ResponsiveButton,
        GenericDataTable
  },
  data(){
    return {
      filters: {
        from:  Utils.formatDatePlusDays(new Date(), -1),
        to:  Utils.formatDatePlusDays(new Date(), -1),
        macroProductCode: null,
        idRegitryPlant: null
      }
    }
  },
  validations(){
    return {
      filters: {
        from: {required},
        to: {required},
        macroProductCode: {},
        idRegitryPlant: {},
      }
    }
  },
  computed: {
    constants(){
        return CommonConstants;
    },
    utils(){
      return Utils;
    },
    uiPermissions(){
      return this.$store.getters['security/uiPermissions'];
    }
  },
  created(){
    this.configuration = config.getConfiguration('StockSummary');
  },
  mounted(){
    this.$store.dispatch('security/setNavbarTitle', 'StockSummary.page_title');
  },
  methods: {
     load(){
        this.submitted = true;

        if(this.v$.invalid){
            return;
        }
        this.submitted = false;

        let filters = {
            from: Utils.formatDateForAPIWithTime(Utils.formatDatePlusDays(this.filters.from, 0)),
            to: Utils.formatDateForAPIWithTime(Utils.formatEndDate(this.filters.to)),
            macroProductCode: this.filters.macroProductCode,
            idRegitryPlant: this.filters.idRegitryPlant
        }
        this.$refs.fiscalDocumentsA18.filterFromView(filters, true);
    },
    dowloadReport(){
        this.$store.dispatch("generic/setLoading", true);
        let filters = {
           from: Utils.formatDateForAPIWithTime(Utils.formatDatePlusDays(this.filters.from, 0)),
            to: Utils.formatDateForAPIWithTime(Utils.formatEndDate(this.filters.to)),
            macroProductCode: this.filters.macroProductCode,
            idRegitryPlant: this.filters.idRegitryPlant
        }
        Service.printtStockSummary(filters, response => {
            
            this.$store.dispatch("generic/setLoading", false);
            if(response.success){
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');
            
                fileLink.href = fileURL;
                let fileName = "StockSummary.pdf";
                fileLink.setAttribute('download',fileName);
                document.body.appendChild(fileLink);
            
                fileLink.click();
            }else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
            }
        })
    }
  }
}

</script>

<template>
  <main>
    <div class="grid">
        <div class="col-12 lg:col-2">
            <label for="from" :class="{'p-error':v$.filters.from.$invalid && submitted}">{{$t('from')}}</label>
            <Calendar
                :class="{'p-invalid':v$.filters.from.$invalid && submitted, 'p-inputtext-sm w-full': true}"
                :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                :dateFormat="constants.DATE_FORMAT_POINT"
                :showTime="false"
                v-model="filters.from"
                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
            </div>
            <div v-if="(v$.filters.from.$invalid && submitted) || v$.filters.from.$pending.$response">
                <small class="p-error" v-for="error in v$.filters.from.$silentErrors" :key="error.$validator">
                    {{error.$message}}
                </small>
            </div>
        <div class="col-12 lg:col-2">
            <label for="to" :class="{'p-error':v$.filters.to.$invalid && submitted}">{{$t('to')}}</label>
            <Calendar
                :class="{'p-invalid':v$.filters.to.$invalid && submitted, 'p-inputtext-sm w-full': true}"
                :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                :dateFormat="constants.DATE_FORMAT_POINT"
                :showTime="false"
                v-model="filters.to"
                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
            <div v-if="(v$.filters.to.$invalid && submitted) || v$.filters.to.$pending.$response">
                <small class="p-error" v-for="error in v$.filters.to.$silentErrors" :key="error.$validator">
                    {{error.$message}}
                </small>
            </div>
        </div>
        <div class="col-12 lg:col-2">
            <label for="plant">{{$t('registryPlant.fk')}}</label>
            <GenericCustomMasterDataAutocompleteV2
                field="label"
                v-model="filters.idRegitryPlant"
                api="masterdata/registry-plant-combo"
                :addEmpty="true"
                :emptyValue="null"
                :emptyLabel="$t('all')"
                :name="'registry-plant'"
                :class="{'p-inputtext-sm w-full': true}" />
        </div>
         <div class="col-12 lg:col-2">
            <label for="macroProductCode">{{$t('macroProductCode')}}</label>
            <GenericCustomMasterDataAutocompleteV2
                field="label"
                v-model="filters.macroProductCode"
                api="fiscal-reports/macro-products-combo"
                :name="'macro-products-combo'"
                :class="{'p-inputtext-sm w-full': true}" />
        </div> 
        <div class="col-12 lg:col-6">
            <div class="p-4">
                <ResponsiveButton :label="$t('btn.search')" icon="pi pi-search" class="mx-1" @click="load()"/>   
                <ResponsiveButton :label="$t('btn.download')" icon="pi pi-download" class="mx-1" @click="dowloadReport"/>   
            </div>
        </div>
        <div class="col-12" style="height: calc(75vh)">
            <GenericDataTable :configuration="configuration" :category="'fiscal-data'" :name="'a18'" ref="fiscalDocumentsA18"/>
        </div>
    </div>
  </main>
</template>